import { Grid } from '@mui/material'
import { makeStyles } from '@material-ui/core/styles'
import { CAR_BRANDS_LIST } from 'src/utils/constants/BuyPolicy'
import Button from '@mui/material/Button'
import IconButton from '@mui/material/IconButton'

const BrandSelector = ({ handleBrandChange }) => {
  const classes = useStyles()

  const handleIconClick = (brand) => {
    handleBrandChange({ brand })
  }

  return (
    <div>
      <div className={classes.selectBrandContainer}>
        <span className={classes.brand}>Select the Brand</span>
      </div>
      <Grid container spacing={2} className={classes.brandListContainer}>
        {CAR_BRANDS_LIST?.map((carBrand) => {
          return (
            <Grid
              item
              xs={4}
              md={3}
              lg={12 / 5}
              className={classes.brandContainer}
              key={carBrand?.value}
            >
              <IconButton
                onClick={() => handleIconClick(carBrand)}
                id='IconButton'
              >
                <img
                  src={carBrand?.icon}
                  alt={carBrand?.label}
                  className={classes.brandIcon}
                />
              </IconButton>
            </Grid>
          )
        })}
      </Grid>
      <div className={classes.viewButtonContainer}>
        <Button variant='contained' className={classes.viewButton} id='Button'>
          View more..
        </Button>
      </div>
    </div>
  )
}

export default BrandSelector

const useStyles = makeStyles({
  selectBrandContainer: {
    textAlign: 'center',
    marginBottom: '10px',
    marginTop: '-15px',
  },
  brand: {
    fontSize: '16px',
    fontFamily: 'Roboto',
    fontWeight: '400',
  },
  brandListContainer: {
    width: '100%',
    height: '100%',
    padding: '5px',
  },
  brandContainer: {
    width: '20%',
    cursor: 'pointer',
  },
  brandIcon: {
    width: '67px',
    height: '38px',
  },
  viewButtonContainer: {
    textAlign: 'center',
    padding: '5px',
  },
  viewButton: {
    background: 'linear-gradient(180deg, #4DC3E3 0%, #1EA0C4 100%) !important',
    color: '#FFFFFF !important',
    fontWeight: '400 !important',
    fontSize: '12px !important',
    fontFamily: 'Roboto !important',
    borderRadius: '5px !important',
  },
})
